import { IAppTheme } from '@msx/platform-services'

export const getStyles = (theme: IAppTheme) => {
  return {
    root: {
      padding: '20px',
    },
    headingMain: {
    },
    learnLink: {
      textDecoration: 'none',
    },
    signInHint: {
      fontSize: '14px',
      fontWeight: 600,
      textAlign: 'center',
    },
  };
};

// Generated by GitHub Copilot | author: Raviteja Madhira | Updated on: 2026-07-21 | 5 lines added | Added signInHint style for the first-time embedded sign-in hint text
